import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledTypeAheadFlyout = styled.div`
  overflow: visible;
  width: 100%;
  position: relative;

  .MuiAutocomplete-inputRoot {
    border: ${toRem(0.8)} solid ${color.neutral30};
    border-radius: ${toRem(8)};
    margin-top: 0;
    line-height: ${toRem(21)};
    padding: ${toRem(18)} ${toRem(16)} ${toRem(9.5)};
    height: ${toRem(52)};

    &.Mui-error {
      border-color: ${color.alert50};
    }

    &.Mui-focused {
      border-color: ${color.base10};
    }
  }

  .MuiAutocomplete-inputRoot[class*='MuiInput-root'] .MuiAutocomplete-input:first-child {
    border-bottom: none;
    font-size: ${toRem(16)};
    &::placeholder {
      color: ${color.neutral40};
      opacity: 1;
    }
  }

  .MuiFormLabel-root {
    font-size: ${toRem(12)};
    color: ${color.neutral40};
    padding: ${toRem(9)} ${toRem(16)} 0 ${toRem(17)};
    font-weight: ${font.fontWeightRegular};
    font-family: ${font.fontSwiss};
    transform: none;
    text-transform: unset;

    &.Mui-error {
      color: ${color.neutral40};
    }

    &.Mui-focused {
      color: ${color.neutral40};
    }
  }

  .MuiInput-root {
    &.MuiInput-underline {
      &:hover:not(.Mui-disabled)::before,
      &::before,
      &::after {
        border: none;
        transition: none;
      }
    }
  }

  .MuiFormHelperText-root {
    &.Mui-error {
      color: ${color.alert50};
      margin-left: 0;
      font-family: ${font.fontSwiss};
      font-weight: ${font.fontWeightMedium};
    }
  }

  .MuiIconButton-root:hover {
    background: none;
  }

  .MuiAutocomplete-listbox {
    max-height: unset;
    padding: 0;
  }

  .MuiAutocomplete-paper {
    display: inherit;
    margin: 0;
    .t-font-m {
      margin: 0;
      font-size: ${toRem(14)};
      gap: ${toRem(8)};
    }
  }

  .flyout-icon {
    background: ${color.neutral10};
    padding: ${toRem(8)};
    border-radius: ${toRem(4)};
    flex-shrink: 0;
    position: relative;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .description-details {
    display: flex;
    gap: ${toRem(8)};
    align-items: center;
    text-decoration: none;
    line-height: ${toRem(20)};
  }

  .MuiPaper-rounded {
    padding: ${toRem(16)} 0;
    border-radius: ${toRem(8)};
    box-shadow: 0 ${toRem(7)} ${toRem(20)} 0 rgba(0, 0, 0, 0.25);
    min-width: ${toRem(345)};
  }

  .closeIcon .MuiAutocomplete-clearIndicator {
    visibility: visible;
  }

  .MuiAutocomplete-clearIndicator {
    .hide-icon,
    .show-icon,
    .MuiTouchRipple-root {
      display: none;
    }

    &:focus {
      outline: ${toRem(2)} solid ${color.base10};
      outline-offset: ${toRem(-2)};
      border-radius: ${toRem(3)};
      color: inherit;
    }
  }

  .MuiFormControl-root .Mui-focused .MuiAutocomplete-clearIndicator .show-icon,
  .MuiAutocomplete-clearIndicator:focus .show-icon {
    display: block;
  }
`;
